// /score/today — deep-link entry that opens KnowMenoApp directly on the
// Menopause Score detail screen. Mirrors the auth wiring of /app so the
// score view is gated behind the same session check.
import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { AuthGate } from "@/knowmeno/AuthGate";
import { ProfileSync } from "@/knowmeno/ProfileSync";
import { ConsentGate } from "@/knowmeno/ConsentGate";
import { AnalyticsBootstrap } from "@/knowmeno/AnalyticsBootstrap";
import { installStorageShim } from "@/knowmeno/storageShim";
import KnowMenoApp from "@/knowmeno/KnowMenoApp";
import { supabase } from "@/integrations/supabase/client";
import { getScoreLabel } from "@/knowmeno/scoreLabel";

export const Route = createFileRoute("/score/today")({
  head: () => ({
    meta: [
      { title: "Menopause Score — KnowMeno" },
      { name: "description", content: "View your daily Menopause Score with a 14-day trend chart and personalized insights to track symptom patterns over time." },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: ScoreTodayPage,
});

function ScoreTodayPage() {
  const [shimReady, setShimReady] = useState(false);
  useEffect(() => { installStorageShim(); setShimReady(true); }, []);

  // Swap the document title to "Vitality Score" for Postmenopause users.
  // Read stage from the locally-cached user blob (set by ProfileSync).
  useEffect(() => {
    try {
      const raw = window.localStorage.getItem("menotrack_user");
      const stage = raw ? (JSON.parse(raw)?.stage ?? null) : null;
      const label = getScoreLabel(stage);
      document.title = `${label} — KnowMeno`;
    } catch { /* no-op */ }
  }, [shimReady]);

  if (!shimReady) return null;
  return (
    <div style={{ background: "#FAF7F5", minHeight: "100vh", padding: "0 16px" }}>
      <AuthGate>
        {(session) => (
          <ProfileSync session={session}>
            <ConsentGate userId={session.user.id}>
              <AnalyticsBootstrap userId={session.user.id} />
              <KnowMenoApp
                sessionEmail={session.user.email ?? ""}
                initialScreen="score-detail"
                signOut={async () => { await supabase.auth.signOut(); }}
              />
            </ConsentGate>
          </ProfileSync>
        )}
      </AuthGate>
    </div>
  );
}
